import Link from 'next/link'

import cn from 'classnames'

import { useTranslation } from 'utils/use-translation'

import styles from './styles.module.scss'

const BreadCrumbs = ({ pages, isInverted = false }) => {
  const { t } = useTranslation()

  return (
    <div className={isInverted ? styles.bg : null}>
      {!isInverted && (
        <div className={cn('container', styles.wrapper)}>
          <Link prefetch={false} href="/">
            <a>{t('main')}</a>
          </Link>
          {pages.map((page) => (
            <span key={page.name}>
              <span className={styles.arrow}>&gt;</span>
              {page.url ? (
                <Link prefetch={false} href={page.url}>
                  <a>{page.name}</a>
                </Link>
              ) : (
                <span>{page.name}</span>
              )}
            </span>
          ))}
        </div>
      )}

      {isInverted && (
        <div className={styles.wrapper}>
          {pages.map((page) => (
            <span key={page.name}>
              <span className={styles.arrow}>&lt;</span>
              {page.url ? (
                <Link prefetch={false} href={page.url}>
                  <a>{page.name}</a>
                </Link>
              ) : (
                <span>{page.name}</span>
              )}
            </span>
          ))}
        </div>
      )}
    </div>
  )
}

export default BreadCrumbs
